import React, { useState, useEffect } from "react";
import { getBlogs } from "../admin/services/BlogAPI";

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await getBlogs();
            const sortedBlogs = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setBlogs(sortedBlogs);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        }
    };

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric'};
        return new Date(date).toLocaleDateString('de-DE', options);
    };

    return (
        blogs.map((blog) => (
            <article className="flex max-w-xl flex-col items-start justify-between bg-white border-gray-200 border-2 p-5 rounded-3xl drop-shadow-lg">
                <div className="flex items-center gap-x-4 text-xs">
                    <time dateTime="2020-03-16" className="text-gray-500">{formatDate(blog.createdAt)}</time>
                </div>
                <div className="group relative">
                    <h1 className="mt-3 text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-500 text-transparent bg-clip-text">
                        <a onClick={() => window.location.href=`/blogs/${blog.id}`} className="cursor-pointer">
                            {blog.title}
                        </a>
                    </h1>
                    <p className="mt-5 line-clamp-2 text-sm/6 text-gray-600">{blog.content}</p>
                </div>
                <div className="relative mt-4 flex gap-x-4">
                    <div className="text-sm/6">
                        <p className="font-semibold text-gray-900">
                            <span className="absolute inset-0"></span>
                            {blog.author}
                        </p>
                    </div>
                </div>
            </article>
            ))
    );
};

export default BlogList;